<template>
    <button
        class="btn btn-sm position-relative notification-bell"
        :title="isWsConnected ? 'Notifications (connected)' : 'Notifications (disconnected)'"
        @click="goToNotifications"
    >
        <i class="fas fa-bell fa-lg" :class="isWsConnected ? 'text-success' : 'text-warning'"></i>
        <span
            v-if="unreadCount > 0"
            class="badge bg-danger position-absolute notification-badge"
        >{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </button>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import Emitter from '@/services/Emitter';
import WebSocketService from '@/services/WebSocketService';

const router = useRouter();
const unreadCount = ref(0);
const isWsConnected = ref(false);

const loadUnreadCount = async () => {
    try {
        unreadCount.value = await ApiService.getUnreadNotificationCount(true);
    } catch (error) {
        console.error('[NotificationBell] Error loading unread count:', error);
    }
};

const goToNotifications = () => {
    router.push('/notification/list');
};

const onWsConnected = () => {
    isWsConnected.value = true;
};

const onWsDisconnected = () => {
    isWsConnected.value = false;
};

const onNotificationRefresh = () => {
    loadUnreadCount();
};

let unsubConnected: Function;
let unsubDisconnected: Function;
let unsubRefresh: Function;

onMounted(() => {
    isWsConnected.value = WebSocketService.getConnected();
    loadUnreadCount();

    unsubConnected = Emitter.on('websocket:connected', onWsConnected);
    unsubDisconnected = Emitter.on('websocket:disconnected', onWsDisconnected);
    unsubRefresh = Emitter.on('notification:refresh', onNotificationRefresh);
});

onUnmounted(() => {
    if (unsubConnected) unsubConnected();
    if (unsubDisconnected) unsubDisconnected();
    if (unsubRefresh) unsubRefresh();
});
</script>

<style scoped>
.notification-bell {
    padding: 0.25rem 0.5rem;
}

.notification-badge {
    top: 0;
    right: 0;
    transform: translate(40%, -40%);
    font-size: 0.65rem;
    min-width: 1.1rem;
    padding: 0.15rem 0.3rem;
    border-radius: 0.75rem;
}
</style>
